import { tenant } from '@tenant';
import React from 'react';

import { CONTACT_SUPPORT_EMAIL_TEST_ID } from '../constants';

type ContactSupportCTAProps = {
  reachOutPrefix: React.ReactNode;
  email?: string;
};

export const ContactSupportCTA = ({
  reachOutPrefix,
  email = tenant.support.email
}: ContactSupportCTAProps) => {
  return (
    <p>
      {reachOutPrefix}{' '}
      <a
        data-testid={CONTACT_SUPPORT_EMAIL_TEST_ID}
        href={`mailto:${email}`}
        className="text-feedback-info"
      >
        {email}
      </a>
      .
    </p>
  );
};
